export default __webpack_public_path__ + "static/meet-john-4-3c88913a329dfcb5af8446f2272b9b59.webp";